export default __webpack_public_path__ + "static/media/image43.3ea26357.jpg";